<footer class="footer" [ngClass]="{'no-sidebar': !sideBar}">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                © {{currentYear}} AutoAction Cloud All rights reserved.
            </div>
            <div class="col-md-6">
                <div class="text-md-right footer-links d-none d-md-block">
                    <a href="javascript: void(0);" [routerLink]="['/privacy']"  >Privacy</a>
                    <a href="javascript: void(0);">Legal</a>
                    <a href="javascript: void(0);" [routerLink]="['/contact']">Contact</a>
                </div>
            </div>
        </div>
    </div>
</footer>
